"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var sticky = __importStar(require("stickyfilljs"));
var index_1 = __importDefault(require("../Badge/index"));
var HeaderRow = /** @class */ (function (_super) {
    __extends(HeaderRow, _super);
    function HeaderRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.divRef = react_1.default.createRef();
        return _this;
    }
    HeaderRow.prototype.componentDidMount = function () {
        if (this.props.fixedHeader === true && this.divRef.current) {
            sticky.add(this.divRef.current);
        }
    };
    HeaderRow.prototype.render = function () {
        var _a;
        var _b;
        var _c = this.props, line = _c.line, className = _c.className, title = _c.title, badge = _c.badge, badgeColor = _c.badgeColor, children = _c.children, fixedHeader = _c.fixedHeader, rest = __rest(_c, ["line", "className", "title", "badge", "badgeColor", "children", "fixedHeader"]);
        var baseClassName = "emankit__header_row";
        var cn = classnames_1.default(baseClassName, className, (_a = {
                emankit__bottom_line: line
            },
            _a[baseClassName + "--fixed"] = fixedHeader,
            _a));
        var badgeItem = null;
        if (badge) {
            badgeItem = (react_1.default.createElement("div", { className: "badge_container" },
                react_1.default.createElement(index_1.default, { color: badgeColor }, badge)));
        }
        var headingElement = react_1.default.createElement("h" + ((_b = this.props.level) !== null && _b !== void 0 ? _b : "1"), {}, title);
        return (react_1.default.createElement("div", __assign({ className: cn, ref: this.divRef }, rest),
            react_1.default.createElement("div", { className: baseClassName + "__title" },
                headingElement,
                badgeItem),
            children && react_1.default.createElement("div", { className: baseClassName + "__button_bar" }, children)));
    };
    HeaderRow.defaultProps = {
        line: true,
        fixedHeader: false,
        level: 1,
    };
    return HeaderRow;
}(react_1.Component));
exports.default = HeaderRow;
//# sourceMappingURL=index.js.map